import { render, staticRenderFns } from "./ItemIndicators.vue?vue&type=template&id=0ac633a0&scoped=true"
import script from "./ItemIndicators.vue?vue&type=script&lang=ts"
export * from "./ItemIndicators.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac633a0",
  null
  
)

export default component.exports